<template>
	<div class="home-header">
    <div class="header-address">
      <img src="../../../assets/image/home/address@2x.png" class="header-icon">
      <div>{{ stateAddress?stateAddress.name:address}}</div>
    </div>
    <div class="scan-address" @click="scanOver">
      <img src="../../../assets/image/home/scan@2x.png" class="scan-icon">
    </div>
    <input style="max-width:50vw;" type="search" readonly="true" placeholder="想找什么？" autocomplete="off" @click="onSearch">
    <div class="header-item" @click="rightClick">
      <img src="../../../assets/image/home/notice@2x.png" class="header-icon">
      <span v-if="isHasUnreadCount"></span>
      <!-- <span v-if="isHasUnreadCount">{{systemUnreadCount}}</span> -->
    </div>
    <div id="yourElement" style="display:none;"></div>
	</div>
</template>

<script>
import { Header, Indicator, Toast, MessageBox } from 'mint-ui';
import { mapState, mapGetters, mapActions } from 'vuex';
import { ENUM } from '../../../const/enum';
import Quagga from 'quagga';
export default {
  name: "myHomeHeader",
  computed: {
    ...mapState({
      isOnline: state => state.auth.isOnline,
      lastOrderMsgTime: state => state.message.lastOrderMsgTime,
      lastSystemMsgTime: state => state.message.lastSystemMsgTime,
      orderUnreadCount: state => state.message.orderUnreadCount,
      systemUnreadCount: state => state.message.systemUnreadCount,
    }),
    ...mapGetters({
      isHasUnreadCount: 'isHasUnreadCount',
      stateAddress:state => state.home.address,
    }),
  },
  data () {
    return {
      address:'定位中...',
      clipboardText:'http://hlmall.bestegou.com/hl2208.html'
    }
  },
  created() {
     window.sendCoordinate = (longitude, latitude)=>{
      var _that = this
      let type = null
      if(window.android){
        type = 'android'
      }else if(typeof window.webkit == 'object'){
        type = 'ios'
      }else{
        type = isIphone()?'ios':'android'
      }
      this.fetchHomeAddress({lng: longitude, lat: latitude, type: type }).then(response => {
          if(response && response.result){
            window.address  =  response.result
            if(response.result.addressComponent.street_number){
                _that.address = response.result.addressComponent.street + response.result.addressComponent.street_number
            }else if(response.result.addressComponent.street){
              _that.address = response.result.addressComponent.street + response.result.addressComponent.street_number
            }else if(response.result.addressComponent.district){
              _that.address = response.result.addressComponent.district
            }else if(response.result.addressComponent.province){
              _that.address = response.result.addressComponent.province
            }else if(response.result.sematic_description){
              _that.address = response.result.sematic_description
            }else{
              _that.address = response.result.formatted_address
            }
          }
        },
        error => {
          // Toast('请求异常:'+error.errorMsg);
        }
      )
      if (this.isOnline) {
				this.getMessageCount(ENUM.MESSAGE_TYPE.SYSTEM);
				// this.getMessageCount(ENUM.MESSAGE_TYPE.ORDER);
			}
    },
    window.sendScanOver=(result)=>{
      this.bybarcode({barcode:result}).then(response => {
          if(response && response.id){
             this.$router.push({'name': 'product', 'query': {'id': response.id }});
          }
        },
        error => {
          MessageBox.alert(error.errorMsg, "商品暂未找到！");
        }
      )
    }
    // 调用原生app 定位方法
		if(window.android){ 
        window.android.acquireJpushRegistrationID();
        window.android.acquireAppVersion();
		}else if(isIphone() && window.webkit){
        window.webkit.messageHandlers.acquireJpushRegistrationID.postMessage(null);
        window.webkit.messageHandlers.acquireAppVersion.postMessage(null);
		}else{
			  window.version = '1.0.5'
		}
		window.sendAppVersion = (version)=>{
			window.version = version
		}
		window.sendJpushRegistrationID= (registrationID)=>{
			window.device_id = registrationID
		}
    this.getCity()
  },
  methods: {
    ...mapActions({
      fetchHomeAddress:'fetchHomeAddress',
      'bybarcode':'bybarcode'
    }),
     scanOver(){
      if(window.android){
        window.android.scanOver();
      }else if(typeof window.webkit == 'object'){
        window.webkit.messageHandlers.scanOver.postMessage('');
      }else if(isWeixin()){
        window.location.href = 'http://youpinapi.bestegou.com/v2/ecapi.scan.url'
      }else{
        //h5 的扫一扫
        // if (navigator.mediaDevices && typeof navigator.mediaDevices.getUserMedia === 'function') {
        //   Quagga.init({
        //     inputStream : {
        //       name : "Live",
        //       type : "LiveStream",
        //       target: document.querySelector('#yourElement')
        //     },
        //     decoder : {
        //       readers : ["code_128_reader"]
        //     }
        //   }, function(err) {
        //       if (err) {
        //           console.log(err);
        //           Toast(err);
        //           return
        //       }
        //       console.log("Initialization finished. Ready to start");
        //       Quagga.start();
        //       Quagga.onDetected(function(data){
        //         console.log(data)
        //         alert(data.codeResult.code)
        //     })
        //   });
        // }else{
          Toast('该浏览器暂不支持扫一扫!');
        // }
      }
    },
    // 获取未读消息数字
    getMessageCount(type) {
      if (this.user != null) {
        let after = null
        // let joined_at = this.user.joined_at ? this.user.joined_at : Date.parse( new Date()) / 1000;						
        if (type === ENUM.MESSAGE_TYPE.SYSTEM) {
          after = this.lastSystemMsgTime ? this.lastSystemMsgTime : Date.parse( new Date()) / 1000
        }
        // } else if (type === ENUM.MESSAGE_TYPE.ORDER) {
        //   after = this.lastOrderMsgTime ? this.lastOrderMsgTime : '0'
        // }
        messageCount(after, type).then(res => {
          if (res) {
            if (type === ENUM.MESSAGE_TYPE.SYSTEM) {
              this.saveSystemUnread(res.count);
            }
            // } else if (type === ENUM.MESSAGE_TYPE.ORDER) {
            //   this.saveOrderUnread(res.count);
            // }
          }
        });
      }
    },
    onSearch() {
      this.$router.push({ name: "search", params: { isFromHome: true } });
    },
    rightClick() {
      if (this.isOnline) {
        this.$router.push({ name: 'systemMessageList' });
      } else {
        this.$router.push({ name: "signin" });
      }
    },
    updateMessageBox(){
      MessageBox({
          title: '系统升级',
          message:'请复制以下地址在浏览器中打开:'+this.clipboardText+'。下载最新APP',
          confirmButtonText: '复制',
          confirmButtonClass: 'confirm-button-red',
          showCancelButton: true
        }).then(action => {
          if (action == 'confirm') {
            var btn = document.getElementById('clipboardText');
            if(btn){
              var clipboard = new ClipboardJS(btn);
              clipboard.on("success", function(e){
                Toast('复制成功!');
              });
              clipboard.on("error", function(e){
                Toast('复制失败!');
              });
              btn.click()
            }
          }
      });
    },
    h5location(){
        var _that = this
        var geolocation = new BMap.Geolocation();
        geolocation.getCurrentPosition(function(r) {
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            if(r.latitude==null){
              Toast("您已拒绝地理位置授权");
              return;
            }else{
              sendCoordinate(r.point.lng, r.point.lat)
            }
          }
        })
    },
    getCity(){
      var _that = this
      if(window.android){
        // 调用原生app 定位方法
        window.android.acquireCoordinate();
        if(typeof window.android.acquireAppVersion == 'function'){
          // window.android.acquireAppVersion();
        }else{  
          // this.updateMessageBox()
        }
      }else if(isIphone()){
        if(typeof window.webkit == 'object'){
          window.webkit.messageHandlers.acquireCoordinate.postMessage(null);
        }else{
          // this.updateMessageBox()
        }
      }else{
        this.h5location()
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.home-header {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background-color: #eb8419;
  z-index:999;
  .header-address {
    font-size:12px;
    padding-left: 6px;
    text-align: center;
    width: 22vw;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    div{
      width: 18vw;
      line-height: 12px;
      text-overflow:ellipsis;
    }
  }
  .header-item {
    width: 50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    span {
			width: 7px;
			height: 7px;
			background-color: red;
			border-radius: 50%;
			position: absolute;
			top: 12px;
      right: 24px;
			font-size: 18px;
		}
  }
  input {
    margin-left: 10px;
    flex: 1;
    flex-basis: 200px;
    border-radius: 16px;
    border: 0px;
    background: url("../../../assets/image/change-icon/search@2x.png") no-repeat
      8px center;
    background-size: 16px;
    background-color: #e9ecf0;
    padding: 9px;
    padding-left: 30px;
    color: #a4aab3;
    font-family: "PingFangSC";
    font-size: 14px;
    height: 32px;
    border: 0px;
    padding-top: 0px;
    padding-bottom: 0px;
    &:focus {
      outline-offset: 0px;
      outline: none;
    }
  }
  .header-icon {
    width: 20px;
    height: 20px;
  }
  .scan-address {
    font-size:12px;
    text-align: center;
    width: 10vw;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .scan-icon {
    width: 20px;
    height: 20px;
  }
  span {
    width: 7px;
    height: 7px;
    position: absolute;
    right: 15px;
    top: 25%;
    background-color: $primaryColor;
    border-radius: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/home/child/HomeHeader.vue